import { InventoryPurchaseOrderFormData, InventoryPurchaseOrderRow } from './types';

export const purchaseOrderStatusOptions = [
  { id: 'all', name: 'Tất cả' },
  { id: 'draft', name: 'Mới tạo' },
  { id: 'pending_quote', name: 'Chờ báo giá' },
  { id: 'submitted', name: 'Gửi duyệt' },
  { id: 'approved', name: 'Đã duyệt mua' },
  { id: 'rejected', name: 'Từ chối duyệt' },
  { id: 'partial_received', name: 'Đã nhập một phần' },
  { id: 'received', name: 'Đã nhập đủ' },
  { id: 'cancelled', name: 'Hủy phiếu mua' },
];

export const inventoryPurchaseOrderRows: InventoryPurchaseOrderRow[] = [];

export const createDefaultPurchaseOrderForm = (companyId: string, defaultStatusId = ''): InventoryPurchaseOrderFormData => ({
  po_no: '',
  purchase_type: 'reserve',
  status: defaultStatusId,
  company_id: companyId,
  company_name: '',
  supplier_id: '',
  supplier_name: '',
  warehouse_id: '',
  warehouse_name: '',
  order_id: null,
  order_no: null,
  material_request_id: null,
  material_request_no: null,
  requested_by_id: null,
  requested_by_name: null,
  approved_by_id: null,
  approved_by_name: null,
  approved_at: null,
  note: '',
  lines: [],
});
